import { useState } from "react";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import Title from "src/components/Title";
import API from "src/services/api";

const ImportSite = () => {
  const [content, setContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();

    if (!content.trim()) {
      setIsSuccess(false);
      setErrorMessage("Bitte Inhalt eingeben.");
      return;
    }

    setIsLoading(true);
    setIsSuccess(false);
    setErrorMessage("");

    const result = await API.importOSMSwipes(content);

    if (result.status) {
      setIsSuccess(true);
      setContent("");
    } else {
      setErrorMessage("Import konnte nicht ausgefuehrt werden.");
    }

    setIsLoading(false);
  };

  return (
    <Row>
      <Col md={10} lg={8}>
        <Title>Import</Title>
        <Form onSubmit={onSubmit}>
          <Form.Group controlId="importOsmText" className="mb-3">
            <Form.Label>Import Daten</Form.Label>
            <Form.Control
              as="textarea"
              rows={12}
              value={content}
              onChange={(event) => setContent(event.target.value)}
              placeholder="Daten fuer OSM Import einfuegen"
            />
          </Form.Group>

          <Button type="submit" disabled={isLoading}>
            {isLoading ? "Import laeuft..." : "Submit"}
          </Button>
        </Form>

        {isSuccess && (
          <Alert variant="success" className="mt-3 mb-0">
            Import erfolgreich gestartet.
          </Alert>
        )}

        {errorMessage && (
          <Alert variant="danger" className="mt-3 mb-0">
            {errorMessage}
          </Alert>
        )}
      </Col>
    </Row>
  );
};

export default ImportSite;
